"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GetPackages;
var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard3(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _externalContext = _interopRequireDefault(require("common-components/dist/common/components/App/externalContext"));
var _ammo = _interopRequireDefault(require("./ammo.wasm"));
var style = require("./style_css.js")["default"];
var containers = {};
function Canvas(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  var fullPage = props.fullPage,
    packages = props.packages,
    progressRef = props.progressRef,
    editor = props.editor,
    className = props.className;
  wapp.styles.use(style);
  var container = (0, _react.useRef)();
  var composition = (0, _react.useRef)();
  var compositionBg = (0, _react.useRef)();
  if (!containers[wapp.globals.WAPP]) {
    containers[wapp.globals.WAPP] = {};
  }
  (0, _react.useEffect)(function didMount() {
    var THREE = packages.THREE,
      AmmoLib = packages.AmmoLib,
      postprocessing = packages.postprocessing,
      LineMaterial = packages.LineMaterial,
      OBJLoader = packages.OBJLoader,
      OrbitControls = packages.OrbitControls,
      MTLLoader = packages.MTLLoader,
      LineGeometry = packages.LineGeometry,
      LineSegments2 = packages.LineSegments2,
      Sky = packages.Sky;
    var BloomEffect = postprocessing.BloomEffect,
      BrightnessContrastEffect = postprocessing.BrightnessContrastEffect,
      EffectPass = postprocessing.EffectPass,
      EffectComposer = postprocessing.EffectComposer,
      RenderPass = postprocessing.RenderPass,
      KernelSize = postprocessing.KernelSize,
      BlendFunction = postprocessing.BlendFunction;
    containers[wapp.globals.WAPP].current = container.current;
    var physicsWorld;
    var transformAux1;
    var scene;
    var camera;
    var composer;
    var renderer;
    var reqId = null;
    var rigidBodies = [];
    var gravityConstant = -9.8;
    var collisionConfiguration;
    var dispatcher;
    var broadphase;
    var solver;
    var softBodySolver;
    var Ammo = null;
    var clock = new THREE.Clock();
    var moveing = 0;
    var removeInputListeners;
    var lightBulb;
    var wireCylinder;
    var debugDrawer;
    var controls;
    var target;
    var sunLightTargetP = -1;
    var cameraP = -1;
    var disableCameraAnim = false;
    var removeControlListeners;
    var bgRenderer;
    var bgScene;
    var bgCamera;
    var bgTarget;
    var bgComposer;
    var sunLightTarget;
    var sunLight;
    var wallMaterialParams = {
      color: 0x1d3932,
      side: THREE.DoubleSide,
      roughness: 0.8,
      metalness: 0.2,
      bumpScale: 0.0005
    };
    function initAmmo() {
      return _initAmmo.apply(this, arguments);
    }
    function _initAmmo() {
      _initAmmo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return AmmoLib();
            case 2:
              Ammo = _context3.sent;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _initAmmo.apply(this, arguments);
    }
    function initBgGraphics() {
      var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
      bgScene = new THREE.Scene();
      bgScene.background = new THREE.Color(0xe5693e);
      bgScene.fog = new THREE.FogExp2(0xe5693e, 0.0225);
      bgCamera = new THREE.PerspectiveCamera(60, parentContainer.offsetWidth / parentContainer.offsetHeight, 0.01, 1000);
      bgCamera.position.z = 3.8;
      bgCamera.position.y = 1.3;
      bgCamera.position.x = -1.35;
      bgCamera.lookAt(-1.6, 1.25, 2);
      bgTarget = new THREE.Vector3(-1.6, 1.25, 2);
      bgRenderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: compositionBg.current,
        alpha: false,
        powerPreference: "high-performance",
        stencil: false
      });
      bgRenderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
      bgRenderer.shadowMap.enabled = true;
      bgRenderer.shadowMap.type = THREE.PCFSoftShadowMap;
      bgRenderer.toneMappingExposure = 0.6;
      bgRenderer.toneMapping = THREE.ACESFilmicToneMapping;
      var renderScene = new RenderPass(bgScene, bgCamera);
      var brightnessContrastEffect = new EffectPass(bgCamera, new BrightnessContrastEffect({
        blendFunction: BlendFunction.NORMAL,
        kernelSize: KernelSize.MEDIUM,
        brightness: 0.05,
        contrast: 0.2
      }));
      brightnessContrastEffect.renderToScreen = true;
      bgComposer = new EffectComposer(bgRenderer);
      bgComposer.addPass(renderScene);
      bgComposer.addPass(brightnessContrastEffect);
      var groundGeo = new THREE.PlaneGeometry(10000, 10000);
      var groundMat = new THREE.MeshLambertMaterial({
        color: 0xcb9779
      });
      var ground = new THREE.Mesh(groundGeo, groundMat);
      ground.position.y = -0.2;
      ground.rotation.x = -Math.PI / 2;
      ground.receiveShadow = true;
      var sky = new Sky();
      sky.scale.setScalar(10000);
      var skyUniforms = sky.material.uniforms;
      skyUniforms["turbidity"].value = 4;
      skyUniforms["rayleigh"].value = 5;
      skyUniforms["mieCoefficient"].value = 0.005;
      skyUniforms["mieDirectionalG"].value = 0.8;
      var pmremGenerator = new THREE.PMREMGenerator(bgRenderer);
      var phi = THREE.MathUtils.degToRad(87);
      var theta = THREE.MathUtils.degToRad(310);
      var sun = new THREE.Vector3();
      sun.setFromSphericalCoords(1, phi, theta);
      sky.material.uniforms["sunPosition"].value.copy(sun);
      bgScene.environment = pmremGenerator.fromScene(sky).texture;
      var planeGeometry = new THREE.PlaneGeometry(8, 10, 32, 32);
      var planeMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var plane = new THREE.Mesh(planeGeometry, planeMaterial);
      plane.receiveShadow = true;
      plane.position.y = 0.05;
      plane.rotation.set(Math.PI / -2, 0, 0);
      var wallGeometry = new THREE.PlaneGeometry(6, 4.5, 32, 32);
      var wallMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var wall = new THREE.Mesh(wallGeometry, wallMaterial);
      wall.receiveShadow = true;
      wall.rotation.set(Math.PI, 0, 0);
      wall.position.z = -4;
      wall.position.y = 4.5 / 2;
      var wallBackGeometry = new THREE.BoxGeometry(6, 0.1, 4.5);
      var wallBackMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var wallBack = new THREE.Mesh(wallBackGeometry, wallBackMaterial);
      wallBack.receiveShadow = true;
      wallBack.castShadow = true;
      wallBack.rotation.set(Math.PI / 2, 0, 0);
      wallBack.position.z = 4;
      wallBack.position.y = 4.5 / 2;
      var wallSideLeftShape = new THREE.Shape();
      wallSideLeftShape.moveTo(0, 0);
      wallSideLeftShape.lineTo(8, 0);
      wallSideLeftShape.lineTo(8, 4.5);
      wallSideLeftShape.lineTo(0, 4.5);
      wallSideLeftShape.lineTo(0, 0);
      function drawWindow() {
        var startX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7.5;
        var startY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
        return new THREE.Shape().moveTo(startX, startY).lineTo(startX - width, startY).lineTo(startX - width, startY + 2.8).bezierCurveTo(startX - width, startY + 3.3, startX - width / 4 * 3, startY + 3.8, startX - width / 4 * 2, startY + 3.8).bezierCurveTo(startX - width / 4, startY + 3.8, startX, startY + 3.3, startX, startY + 2.8).lineTo(startX, startY);
      }
      wallSideLeftShape.holes.push(drawWindow(), drawWindow(5, 0.4));
      var wallSideLeftGeometry = new THREE.ExtrudeGeometry(wallSideLeftShape, {
        steps: 3,
        depth: 0.3,
        bevelEnabled: false
      });
      var wallSideLeftMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var wallSideLeft = new THREE.Mesh(wallSideLeftGeometry, wallSideLeftMaterial);
      wallSideLeft.receiveShadow = true;
      wallSideLeft.castShadow = true;
      wallSideLeft.traverse(function (child) {
        child.receiveShadow = true;
        child.castShadow = true;
      });
      wallSideLeft.rotation.set(0, Math.PI / 2, 0);
      wallSideLeft.position.x = -3;
      wallSideLeft.position.z = 4;
      var wallSideRightGeometry = new THREE.PlaneGeometry(8, 4.5, 32, 32);
      var wallSideRightMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var wallSideRight = new THREE.Mesh(wallSideRightGeometry, wallSideRightMaterial);
      wallSideRight.receiveShadow = true;
      wallSideRight.rotation.set(Math.PI, Math.PI / 2, 0);
      wallSideRight.position.x = 3;
      wallSideRight.position.y = 4.5 / 2;
      var ceilingGeometry = new THREE.BoxGeometry(6, 0.05, 8);
      var ceilingMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var ceiling = new THREE.Mesh(ceilingGeometry, ceilingMaterial);
      ceiling.castShadow = true;
      ceiling.rotation.set(Math.PI, 0, 0);
      ceiling.position.y = 4.5;
      sunLightTarget = new THREE.Object3D();
      sunLightTarget.position.set(10, 2, -9);
      sunLight = new THREE.DirectionalLight(0xff3020, 8);
      sunLight.position.set(-5, 5, 4);
      sunLight.target = sunLightTarget;
      sunLight.castShadow = true;
      sunLight.shadow.camera.near = 0.01;
      sunLight.shadow.camera.far = 200;
      var hemiLight = new THREE.HemisphereLight(0xf8875f, 0xf8875f, 1.8);
      var plant;
      new OBJLoader().load("/assets/hatchet-on-the-table/obj/plant/plant.obj", function (object) {
        plant = object;
        plant.scale.x = 2.5;
        plant.scale.y = 2.5;
        plant.scale.z = 2.5;
        plant.position.y = 0;
        plant.position.x = -3;
        plant.position.z = -2.5;
        plant.rotation.set(0, 0, 0);
        plant.castShadow = true;
        plant.receiveShadow = true;
        function rec(mesh) {
          if (!mesh.ready) {
            mesh.ready = true;
            mesh.traverse(function (child) {
              child.castShadow = true;
              child.receiveShadow = true;
              if (child.type === "Group") {
                rec(child);
              } else {
                child.material = new THREE.MeshStandardMaterial({
                  color: 0x181a1a,
                  roughness: 1,
                  metalness: 0,
                  emissiveIntensity: 0
                });
              }
            });
          }
        }
        rec(plant);
        bgScene.add(plant);
      }, function (xhr) {}, function (error) {
        console.log(error);
      });
      var sofa;
      new OBJLoader().load("/assets/hatchet-on-the-table/obj/sofa/sofa.obj", function (object) {
        sofa = object;
        sofa.scale.x = 1;
        sofa.scale.y = 1;
        sofa.scale.z = 1;
        sofa.position.y = 0;
        sofa.position.x = -1.5;
        sofa.position.z = -4;
        sofa.rotation.set(0, 0, 0);
        sofa.castShadow = true;
        sofa.receiveShadow = true;
        function rec(mesh) {
          if (!mesh.ready) {
            mesh.ready = true;
            mesh.traverse(function (child) {
              child.castShadow = true;
              child.receiveShadow = true;
              if (child.type === "Group") {
                rec(child);
              } else {
                child.material = new THREE.MeshStandardMaterial({
                  color: 0x181a1a,
                  roughness: 1,
                  metalness: 0,
                  emissiveIntensity: 0
                });
              }
            });
          }
        }
        rec(sofa);
        bgScene.add(sofa);
      }, function (xhr) {}, function (error) {
        console.log(error);
      });
      var lamp1;
      var lamp2;
      new OBJLoader().load("/assets/hatchet-on-the-table/obj/lamp/lamp.obj", function (object) {
        object.scale.x = 1;
        object.scale.y = 1;
        object.scale.z = 1;
        object.castShadow = true;
        object.receiveShadow = true;
        function rec(mesh) {
          if (!mesh.ready) {
            mesh.ready = true;
            mesh.traverse(function (child) {
              child.castShadow = true;
              child.receiveShadow = true;
              if (child.type === "Group") {
                rec(child);
              } else {
                child.material = new THREE.MeshStandardMaterial({
                  color: 0x181a1a,
                  roughness: 1,
                  metalness: 0,
                  emissiveIntensity: 0
                });
              }
            });
          }
        }
        rec(object);
        lamp1 = new THREE.Object3D();
        lamp1.add(object);
        lamp1.position.y = 4.5;
        lamp1.position.x = -1;
        lamp1.position.z = -3;
        lamp1.rotation.set(0, 0, 0);
        lamp2 = new THREE.Object3D();
        lamp2.add(object.clone());
        lamp2.position.y = 4.5;
        lamp2.position.x = 1;
        lamp2.position.z = -3;
        lamp2.rotation.set(0, 0, 0);
        bgScene.add(lamp1);
        bgScene.add(lamp2);
        var spot1LightTarget = new THREE.Object3D();
        spot1LightTarget.position.set(-1, 0, -3);
        var spot1Light = new THREE.SpotLight(0xf8875f, 3, 5, 0.5, 1, 1);
        spot1Light.position.set(-1, 2.75, -3);
        spot1Light.add(new THREE.Mesh(new THREE.SphereGeometry(0.04, 16, 16), new THREE.MeshBasicMaterial({
          color: 0xefab93,
          transparent: true,
          opacity: 0.8
        })));
        spot1Light.target = spot1LightTarget;
        spot1Light.castShadow = true;
        spot1Light.shadow.camera.near = 0.01;
        var spot2LightTarget = new THREE.Object3D();
        spot2LightTarget.position.set(1, 0, -3);
        var spot2Light = new THREE.SpotLight(0xf8875f, 3, 5, 0.5, 1, 1);
        spot2Light.add(new THREE.Mesh(new THREE.SphereGeometry(0.04, 16, 16), new THREE.MeshBasicMaterial({
          color: 0xefab93,
          transparent: true,
          opacity: 0.8
        })));
        spot2Light.position.set(1, 2.75, -3);
        spot2Light.target = spot2LightTarget;
        spot2Light.castShadow = true;
        spot2Light.shadow.camera.near = 0.01;
        bgScene.add(spot1LightTarget);
        bgScene.add(spot1Light);
        bgScene.add(spot2LightTarget);
        bgScene.add(spot2Light);
      }, function (xhr) {}, function (error) {
        console.log(error);
      });
      bgScene.add(ground);
      bgScene.add(sky);
      bgScene.add(hemiLight);
      bgScene.add(sunLightTarget);
      bgScene.add(sunLight);
      bgScene.add(plane);
      bgScene.add(wall);
      bgScene.add(wallBack);
      bgScene.add(wallSideLeft);
      bgScene.add(wallSideRight);
      bgScene.add(ceiling);
    }
    var addedObjects = false;
    function initGraphics() {
      var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(60, parentContainer.offsetWidth / parentContainer.offsetHeight, 0.01, 1000);
      camera.layers.enable(1);
      camera.layers.enable(2);
      camera.layers.enable(3);
      camera.position.z = 3.7;
      camera.position.y = 1.8;
      camera.position.x = -1.5;
      target = new THREE.Vector3(-1.5, 1.25, 2);
      camera.lookAt(target.x, target.y, target.z);
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: composition.current,
        alpha: true,
        powerPreference: "high-performance",
        stencil: false
      });
      renderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      renderer.autoClear = false;
      renderer.toneMappingExposure = Math.pow(1, 4.0);
      var renderScene = new RenderPass(scene, camera);
      var bloomEffect = new EffectPass(camera, new BloomEffect({
        blendFunction: BlendFunction.EXCLUSION,
        kernelSize: KernelSize.MEDIUM,
        luminanceThreshold: 0.1,
        luminanceSmoothing: 0.7,
        intensity: 5
      }));
      bloomEffect.renderToScreen = true;
      composer = new EffectComposer(renderer);
      composer.addPass(renderScene);
      composer.addPass(bloomEffect);
      var tableGeometry = new THREE.BoxGeometry(6, 0.05, 0.9);
      var tableMaterial = new THREE.MeshStandardMaterial({
        color: 0x758c86
      });
      var table = new THREE.Mesh(tableGeometry, tableMaterial);
      table.receiveShadow = true;
      table.castShadow = true;
      table.position.y = 0.9 + -0.05 / 2;
      table.position.z = 2.6;
      table.layers.set(1);
      var hatchet;
      new MTLLoader().load("/assets/hatchet-on-the-table/obj/hatchet/hatchet.mtl", function (materials) {
        materials.preload();
        new OBJLoader().setMaterials(materials).load("/assets/hatchet-on-the-table/obj/hatchet/hatchet.obj", function (object) {
          hatchet = object;
          hatchet.scale.x = 1;
          hatchet.scale.y = 1;
          hatchet.scale.z = 1;
          hatchet.position.y = 0.9;
          hatchet.position.x = -1.5;
          hatchet.position.z = 2.6;
          hatchet.rotation.set(0, 0, 0);
          hatchet.castShadow = true;
          hatchet.receiveShadow = true;
          hatchet.traverse(function (child) {
            child.castShadow = true;
            child.layers.set(1);
          });
          scene.add(hatchet);
          setTimeout( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
            var _progressRef$current, _progressRef$current$;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current = progressRef.current) !== null && _progressRef$current !== void 0 && (_progressRef$current$ = _progressRef$current.actions) !== null && _progressRef$current$ !== void 0 && _progressRef$current$.setShow)) {
                    _context.next = 5;
                    break;
                  }
                  _context.next = 3;
                  return progressRef.current.actions.setShow({
                    message: "",
                    value: false
                  });
                case 3:
                  _context.next = 5;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 1000);
                  });
                case 5:
                  console.log("[APP] Add objects...");
                  console.log("[APP] Call onComplete...");
                  addedObjects = true;
                case 8:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })), 2000);
        }, function (xhr) {}, /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(error) {
            var _progressRef$current2, _progressRef$current3;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  console.log(error);
                  if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current2 = progressRef.current) !== null && _progressRef$current2 !== void 0 && (_progressRef$current3 = _progressRef$current2.actions) !== null && _progressRef$current3 !== void 0 && _progressRef$current3.setShow)) {
                    _context2.next = 6;
                    break;
                  }
                  _context2.next = 4;
                  return progressRef.current.actions.setShow({
                    message: "",
                    value: false
                  });
                case 4:
                  _context2.next = 6;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 1000);
                  });
                case 6:
                  console.log("[APP] Add objects...");
                  console.log("[APP] Call onComplete...");
                  addedObjects = true;
                case 9:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
      var bulb = new THREE.Mesh(new THREE.SphereGeometry(0.04, 16, 16), new THREE.MeshBasicMaterial({
        color: 0xefab93,
        transparent: true,
        opacity: 0.8
      }));
      bulb.layers.set(3);
      var light = new THREE.PointLight(0xf8875f, 1);
      light.shadow.camera.near = 0.01;
      light.shadow.camera.far = 1.5;
      light.lookAt(0, 0, 0);
      light.castShadow = true;
      light.layers.set(1);
      var socketGeometry = new THREE.CylinderGeometry(0.02, 0.02, 0.05, 32);
      var socketMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000
      });
      var socketCylinder = new THREE.Mesh(socketGeometry, socketMaterial);
      socketCylinder.position.set(0, 0.04 + 0.05 / 2, 0);
      socketCylinder.layers.set(1);
      var socketCapGeometry = new THREE.CylinderGeometry(0.001, 0.021, 0.02, 32);
      var socketCapMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000
      });
      var socketCapCylinder = new THREE.Mesh(socketCapGeometry, socketCapMaterial);
      socketCapCylinder.position.set(0, 0.04 + 0.05 + 0.02 / 2, 0);
      socketCapCylinder.layers.set(1);
      lightBulb = new THREE.Group();
      lightBulb.add(socketCylinder, socketCapCylinder, bulb, light);
      lightBulb.position.set(-1.5, 1.35, 2.6);
      lightBulb.layers.set(1);
      var lightBulbShape = new Ammo.btSphereShape(0.04 / 2);
      lightBulbShape.setMargin(0.01);
      createRigidBody(lightBulb, lightBulbShape, 0.1, lightBulb.position, lightBulb.quaternion);
      lightBulb.userData.physicsBody.setFriction(0.5);
      var blanketGeometry = new THREE.BoxGeometry(0.5, 0.05, 0.5);
      var blanketMaterial = new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({}, wallMaterialParams));
      var blanket = new THREE.Mesh(blanketGeometry, blanketMaterial);
      blanket.castShadow = true;
      blanket.rotation.set(Math.PI / -2, 0, 0);
      blanket.position.y = 4.5;
      blanket.position.x = lightBulb.position.x;
      blanket.position.z = lightBulb.position.z;
      var blanketShape = new Ammo.btBoxShape(new Ammo.btVector3(0.5 * 0.5, 0.05 * 0.5, 0.5 * 0.5));
      blanketShape.setMargin(0.01);
      createRigidBody(blanket, blanketShape, 0, blanket.position, new THREE.Quaternion(0, 0, 0, 1));
      blanket.layers.set(1);
      var wireStartY = lightBulb.position.y + 0.07;
      var wireHeight = 4.5 - wireStartY;
      var wireNumSegments = Math.floor(wireHeight / 0.1);
      var segmentLength = wireHeight / wireNumSegments;
      var wirePos = lightBulb.position.clone();
      wirePos.y = wireStartY;
      var wirePositions = [];
      for (var i = 0; i < wireNumSegments + 1; i++) {
        wirePositions.push(wirePos.x, wirePos.y + i * segmentLength, wirePos.z);
      }
      var wireGeometry = new LineGeometry();
      wireGeometry.setPositions(wirePositions);
      var wireMaterial = new LineMaterial({
        color: 0xffffff,
        linewidth: 0.01,
        vertexColors: true,
        dashed: false,
        alphaToCoverage: true,
        worldUnits: true
      });
      wireCylinder = new LineSegments2(wireGeometry, wireMaterial);
      wireCylinder.castShadow = true;
      wireCylinder.receiveShadow = true;
      var softBodyHelpers = new Ammo.btSoftBodyHelpers();
      var wireStart = new Ammo.btVector3(wirePos.x, wirePos.y, wirePos.z);
      var wireEnd = new Ammo.btVector3(wirePos.x, wirePos.y + wireHeight, wirePos.z);
      var wireSoftBody = softBodyHelpers.CreateRope(physicsWorld.getWorldInfo(), wireStart, wireEnd, wireNumSegments - 1, 0);
      var sbConfig = wireSoftBody.get_m_cfg();
      sbConfig.set_viterations(100);
      sbConfig.set_piterations(100);
      wireSoftBody.setTotalMass(0.1, false);
      Ammo.castObject(wireSoftBody, Ammo.btCollisionObject).getCollisionShape().setMargin(0.01 * 3);
      physicsWorld.addSoftBody(wireSoftBody, 1, -1);
      wireCylinder.userData.physicsBody = wireSoftBody;
      wireSoftBody.setActivationState(4);
      wireSoftBody.appendAnchor(0, lightBulb.userData.physicsBody, true, 1);
      wireSoftBody.appendAnchor(wireNumSegments, blanket.userData.physicsBody, true, 1);
      var hemiLight = new THREE.HemisphereLight(0xf8875f, 0xf8875f, 1);
      hemiLight.layers.set(3);
      scene.add(hemiLight);
      scene.add(lightBulb);
      scene.add(wireCylinder);
      scene.add(blanket);
      scene.add(table);
    }
    function initControls() {
      controls = new OrbitControls(camera, renderer.domElement);
      controls.target = target;
      controls.update();
      controls.enableZoom = false;
      controls.enablePan = false;
      controls.enableDamping = false;
      controls.minPolarAngle = Math.PI / 2 - 0.5;
      controls.maxPolarAngle = Math.PI / 2 + 0.1;
      controls.minAzimuthAngle = camera.rotation.y - 0.5;
      controls.maxAzimuthAngle = camera.rotation.y + 0.5;
      var wait;
      var start = function start() {
        if (wait) {
          clearTimeout(wait);
        }
        disableCameraAnim = 1;
      };
      var end = function end() {
        if (wait) {
          clearTimeout(wait);
        }
        disableCameraAnim = 1;
        wait = setTimeout(function () {
          disableCameraAnim = 0;
        }, 5000);
      };
      removeControlListeners = function removeControlListeners() {
        controls.removeEventListener("start", start);
        controls.removeEventListener("end", end);
      };
      controls.addEventListener("start", start);
      controls.addEventListener("end", end);
    }
    function initPhysics() {
      collisionConfiguration = new Ammo.btSoftBodyRigidBodyCollisionConfiguration();
      dispatcher = new Ammo.btCollisionDispatcher(collisionConfiguration);
      broadphase = new Ammo.btDbvtBroadphase();
      solver = new Ammo.btSequentialImpulseConstraintSolver();
      softBodySolver = new Ammo.btDefaultSoftBodySolver();
      physicsWorld = new Ammo.btSoftRigidDynamicsWorld(dispatcher, broadphase, solver, collisionConfiguration, softBodySolver);
      physicsWorld.setGravity(new Ammo.btVector3(0, gravityConstant, 0));
      physicsWorld.getWorldInfo().set_m_gravity(new Ammo.btVector3(0, gravityConstant, 0));
      transformAux1 = new Ammo.btTransform();
    }
    function createRigidBody(threeObject, physicsShape, mass, pos, quat) {
      threeObject.position.copy(pos);
      threeObject.quaternion.copy(quat);
      var transform = new Ammo.btTransform();
      transform.setIdentity();
      transform.setOrigin(new Ammo.btVector3(pos.x, pos.y, pos.z));
      transform.setRotation(new Ammo.btQuaternion(quat.x, quat.y, quat.z, quat.w));
      var motionState = new Ammo.btDefaultMotionState(transform);
      var localInertia = new Ammo.btVector3(0, 0, 0);
      physicsShape.calculateLocalInertia(mass, localInertia);
      var rbInfo = new Ammo.btRigidBodyConstructionInfo(mass, motionState, physicsShape, localInertia);
      var body = new Ammo.btRigidBody(rbInfo);
      threeObject.userData.physicsBody = body;
      if (mass > 0) {
        rigidBodies.push(threeObject);
        body.setActivationState(4);
      }
      physicsWorld.addRigidBody(body);
    }
    function updatePhysics(deltaTime) {
      physicsWorld.stepSimulation(deltaTime, 10);
      if (debugDrawer) {
        physicsWorld.debugDrawWorld();
      }
      var softBody = wireCylinder.userData.physicsBody;
      var wirePositions = wireCylinder.geometry.attributes.position.array;
      var numVerts = wirePositions.length / 3;
      var nodes = softBody.get_m_nodes();
      var positions = [];
      for (var i = 0; i < numVerts; i++) {
        var node = nodes.at(i);
        var nodePos = node.get_m_x();
        positions.push(nodePos.x(), nodePos.y(), nodePos.z());
      }
      wireCylinder.geometry.setPositions(positions);
      wireCylinder.geometry.attributes.position.needsUpdate = true;
      for (var _i = 0, il = rigidBodies.length; _i < il; _i++) {
        var objThree = rigidBodies[_i];
        var objPhys = objThree.userData.physicsBody;
        var ms = objPhys.getMotionState();
        if (ms) {
          ms.getWorldTransform(transformAux1);
          var p = transformAux1.getOrigin();
          var q = transformAux1.getRotation();
          objThree.position.set(p.x(), p.y(), p.z());
          objThree.quaternion.set(q.x(), q.y(), q.z(), q.w());
        }
      }
    }
    function initInput() {
      var wait;
      var click = function click(event) {
        var left = event.offsetX < container.current.offsetWidth / 2;
        moveing = left ? -1 : 1;
        if (wait) {
          clearTimeout(wait);
        }
        wait = setTimeout(function () {
          moveing = 0;
        }, 200);
      };
      container.current.addEventListener("click", click);
      removeInputListeners = function removeInputListeners() {
        if (container.current) {
          container.current.removeEventListener("click", click);
        }
      };
    }
    function sunLightAnim() {
      sunLight.position.y = sunLight.position.y + 0.05 * sunLightTargetP;
      if (sunLight.position.y < 2) {
        sunLightTargetP = 1;
        sunLight.position.y = 2;
      } else if (sunLight.position.y > 5) {
        sunLightTargetP = -1;
        sunLight.position.y = 5;
      }
    }
    var run2 = -1;
    function cameraAnim() {
      if (!disableCameraAnim) {
        camera.position.y = camera.position.y + 0.01 * cameraP;
        if (camera.position.y < 1.2) {
          cameraP = 1;
          camera.position.y = 1.2;
          var physicsBody = lightBulb.userData.physicsBody;
          var resultantImpulse = new Ammo.btVector3(0.01, 0, 0.00001);
          resultantImpulse.op_mul(20);
          physicsBody.setLinearVelocity(resultantImpulse);
          if (addedObjects && run2 < 2) {
            run2 = run2 + 1;
            if (run2 === 2) {
              run2 = -1;
              console.log("[APP] Animation ended 0");
            }
          }
        } else if (camera.position.y > 1.8) {
          cameraP = -1;
          camera.position.y = 1.8;
        }
      }
    }
    var render = function render() {
      if (reqId) {
        cancelAnimationFrame(reqId);
      }
      reqId = requestAnimationFrame(render);
      if (moveing) {
        var physicsBody = lightBulb.userData.physicsBody;
        var resultantImpulse = new Ammo.btVector3(0.01 * moveing, 0, 0.00001);
        resultantImpulse.op_mul(20);
        physicsBody.setLinearVelocity(resultantImpulse);
      }
      if (!editor) {
        cameraAnim();
      }
      if (controls) {
        controls.update();
      }
      if (!editor) {
        sunLightAnim();
      }
      bgCamera.rotation.set(camera.rotation.x, camera.rotation.y, camera.rotation.z);
      bgCamera.position.set(camera.position.x, camera.position.y, camera.position.z);
      bgComposer.render();
      renderer.clear();
      var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
      wireCylinder.material.resolution.set(parentContainer.offsetWidth, parentContainer.offsetHeight);
      var deltaTime = clock.getDelta();
      if (!editor) {
        updatePhysics(deltaTime);
      }
      camera.layers.set(3);
      composer.render();
      renderer.clearDepth();
      camera.layers.set(0);
      camera.layers.enable(1);
      camera.layers.enable(3);
      renderer.render(scene, camera);
    };
    function init() {
      return _init.apply(this, arguments);
    }
    function _init() {
      _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return initAmmo();
            case 2:
              initPhysics();
              initBgGraphics();
              initGraphics();
              //initDebugAmmo();
              initControls();
              render();
              initInput();
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _init.apply(this, arguments);
    }
    init();
    function onResize() {
      if (camera && renderer) {
        var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
        camera.aspect = parentContainer.offsetWidth / parentContainer.offsetHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
        composer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
        bgCamera.aspect = parentContainer.offsetWidth / parentContainer.offsetHeight;
        bgCamera.updateProjectionMatrix();
        bgRenderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
        bgComposer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
      }
    }
    function addResizeListeners() {
      if (container.current && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(container.current);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }
    var removeResizeListeners = addResizeListeners();
    onResize();
    return function willUnmount() {
      removeResizeListeners();
      if (removeInputListeners) {
        removeInputListeners();
      }
      if (removeControlListeners && controls) {
        removeControlListeners();
      }
      if (reqId) {
        cancelAnimationFrame(reqId);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var isCtrl = e.ctrlKey;
      if (isCtrl || !editor) {
        if (e.key === "5") {
          var save = /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 2:
                    console.log("[APP]", "Saving...");
                    _context5.next = 5;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 5:
                    window.dataForServerSaving = {
                      blob: null
                    };
                    console.log("[APP]", "The data for server saving is ready...");
                  case 7:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }));
            return function save() {
              return _ref3.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          save();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.canvas, (0, _defineProperty2["default"])({}, style.fullPage, fullPage), (0, _defineProperty2["default"])({}, className, className)),
    ref: container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.bg
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.center
  }, /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.compositionBg,
    ref: compositionBg
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.composition,
    ref: composition
  })));
}
function getPackages() {
  return _getPackages.apply(this, arguments);
}
function _getPackages() {
  _getPackages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
    var THREE, postprocessing, _yield$import, LineMaterial, _yield$import2, OBJLoader, _yield$import3, OrbitControls, _yield$import4, MTLLoader, _yield$import5, LineGeometry, _yield$import6, LineSegments2, _yield$import7, Sky;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three"));
          });
        case 2:
          THREE = _context7.sent;
          _context7.next = 5;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("postprocessing"));
          });
        case 5:
          postprocessing = _context7.sent;
          _context7.next = 8;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineMaterial.js"));
          });
        case 8:
          _yield$import = _context7.sent;
          LineMaterial = _yield$import.LineMaterial;
          _context7.next = 12;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/loaders/OBJLoader.js"));
          });
        case 12:
          _yield$import2 = _context7.sent;
          OBJLoader = _yield$import2.OBJLoader;
          _context7.next = 16;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/controls/OrbitControls.js"));
          });
        case 16:
          _yield$import3 = _context7.sent;
          OrbitControls = _yield$import3.OrbitControls;
          _context7.next = 20;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/loaders/MTLLoader.js"));
          });
        case 20:
          _yield$import4 = _context7.sent;
          MTLLoader = _yield$import4.MTLLoader;
          _context7.next = 24;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineGeometry.js"));
          });
        case 24:
          _yield$import5 = _context7.sent;
          LineGeometry = _yield$import5.LineGeometry;
          _context7.next = 28;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineSegments2.js"));
          });
        case 28:
          _yield$import6 = _context7.sent;
          LineSegments2 = _yield$import6.LineSegments2;
          _context7.next = 32;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/objects/Sky.js"));
          });
        case 32:
          _yield$import7 = _context7.sent;
          Sky = _yield$import7.Sky;
          return _context7.abrupt("return", {
            THREE: THREE,
            postprocessing: postprocessing,
            AmmoLib: _ammo["default"],
            LineMaterial: LineMaterial,
            OBJLoader: OBJLoader,
            OrbitControls: OrbitControls,
            MTLLoader: MTLLoader,
            LineGeometry: LineGeometry,
            LineSegments2: LineSegments2,
            Sky: Sky
          });
        case 35:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getPackages.apply(this, arguments);
}
function GetPackages(props) {
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
    externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var _useState = (0, _react.useState)(externalSettings.packages),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    packages = _useState2[0],
    _setPackages = _useState2[1];
  function setPackages() {
    return _setPackages2.apply(this, arguments);
  }
  function _setPackages2() {
    _setPackages2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
      var packages;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getPackages();
          case 2:
            packages = _context6.sent;
            _context6.next = 5;
            return _setPackages(packages);
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _setPackages2.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (!packages) {
      setPackages();
    }
  }, [packages]);
  return packages ? /*#__PURE__*/_react["default"].createElement(Canvas, Object.assign({}, props, {
    packages: packages
  })) : null;
}